import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AllAirportIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AllAirportGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.1318 22.0005H7.87676C7.58592 22.0005 7.35058 21.7652 7.35058 21.4743V11.8612C7.35058 11.6464 7.48059 11.4543 7.67944 11.3731L14.9345 8.43487C15.0958 8.37013 15.2813 8.38965 15.4257 8.48626C15.5711 8.58492 15.658 8.74832 15.658 8.92303V21.4743C15.658 21.7652 15.4226 22.0005 15.1318 22.0005ZM8.40294 20.9481H14.6056V9.70409L8.40294 12.2158V20.9481Z"
        fill="#696969"
      />
      <path
        d="M21.0364 22.0005H15.1318C14.8409 22.0005 14.6056 21.7652 14.6056 21.4743V6.6919C14.6056 6.40106 14.8409 6.16572 15.1318 6.16572H18.7591C19.0499 6.16572 19.2852 6.40106 19.2852 6.6919V9.38961H21.0364C21.3273 9.38961 21.5626 9.62495 21.5626 9.91579V21.4743C21.5626 21.7652 21.3273 22.0005 21.0364 22.0005ZM15.658 20.9481H20.5102V10.442H18.7591C18.4682 10.442 18.2329 10.2066 18.2329 9.91579V7.21808H15.658V20.9481Z"
        fill="#696969"
      />
      <path
        d="M6.21754 9.17071C5.92465 9.17071 5.63227 9.1039 5.36147 8.96825L3.33074 7.95598C3.3297 7.95598 3.32817 7.95494 3.32714 7.95392C2.68945 7.6302 2.43407 6.84709 2.75779 6.20992C3.04091 5.65085 3.68014 5.37543 4.28289 5.55322L6.05772 6.07632L11.746 3.42486C12.6622 3.02611 13.4499 3.4968 13.7624 4.16583C14.0758 4.83589 13.9304 5.74334 13.0476 6.1832L7.02941 8.98984C6.77043 9.1111 6.49399 9.17071 6.21754 9.17071ZM3.80297 7.01563L5.83062 8.02688C6.06751 8.14404 6.34242 8.14713 6.58444 8.03613L12.5903 5.23566C12.9736 5.04451 12.8549 4.70948 12.8092 4.61185C12.7635 4.51422 12.5826 4.20693 12.1797 4.3837L6.32238 7.1143C6.20625 7.16877 6.07368 7.17802 5.95138 7.14205L3.98437 6.56243C3.87132 6.52749 3.75005 6.58093 3.69609 6.68677C3.63494 6.80702 3.68325 6.95397 3.80297 7.01563Z"
        fill="#696969"
      />
      <path
        d="M7.99957 6.28494C7.87214 6.28494 7.74625 6.23869 7.64759 6.15031L4.65082 3.45363C4.51979 3.33545 4.45658 3.15869 4.48227 2.98397C4.50848 2.81029 4.6205 2.66025 4.7803 2.58522L5.73862 2.13818C6.19081 1.92648 6.71391 1.96038 7.1368 2.22964L10.4131 4.321C10.575 4.42479 10.6675 4.60773 10.6551 4.79991C10.6423 4.99106 10.5261 5.16063 10.3525 5.24182L8.22205 6.2356C8.15114 6.26849 8.07511 6.28494 7.99957 6.28494ZM5.94572 3.20288L8.09258 5.13495L9.0396 4.69304L6.57108 3.11758C6.45392 3.04359 6.30952 3.03126 6.18364 3.09189L5.94572 3.20288Z"
        fill="#696969"
      />
      <path
        d="M19.1835 21.9172H17.0068C16.716 21.9172 16.4806 21.6819 16.4806 21.3911V17.9812C16.4806 17.6903 16.716 17.455 17.0068 17.455H19.1835C19.4743 17.455 19.7097 17.6903 19.7097 17.9812V21.3911C19.7097 21.6819 19.4743 21.9172 19.1835 21.9172ZM17.533 20.8649H18.6573V18.5073H17.533V20.8649Z"
        fill="#696969"
      />
      <path
        d="M19.1835 16.6318H17.0068C16.716 16.6318 16.4806 16.3965 16.4806 16.1056C16.4806 15.8148 16.716 15.5794 17.0068 15.5794H19.1835C19.4743 15.5794 19.7097 15.8148 19.7097 16.1056C19.7097 16.3965 19.4743 16.6318 19.1835 16.6318Z"
        fill="#696969"
      />
      <path
        d="M13.3359 19.7519H12.2476C11.9567 19.7519 11.7214 19.5165 11.7214 19.2257C11.7214 18.9349 11.9567 18.6995 12.2476 18.6995H13.3359C13.6267 18.6995 13.8621 18.9349 13.8621 19.2257C13.8621 19.5165 13.6267 19.7519 13.3359 19.7519Z"
        fill="#696969"
      />
      <path
        d="M10.7605 19.7519H9.67216C9.38131 19.7519 9.14597 19.5165 9.14597 19.2257C9.14597 18.9349 9.38131 18.6995 9.67216 18.6995H10.7605C11.0513 18.6995 11.2867 18.9349 11.2867 19.2257C11.2867 19.5165 11.0513 19.7519 10.7605 19.7519Z"
        fill="#696969"
      />
      <path
        d="M13.3359 17.8291H12.2476C11.9567 17.8291 11.7214 17.5937 11.7214 17.3029C11.7214 17.012 11.9567 16.7767 12.2476 16.7767H13.3359C13.6267 16.7767 13.8621 17.012 13.8621 17.3029C13.8621 17.5937 13.6267 17.8291 13.3359 17.8291Z"
        fill="#696969"
      />
      <path
        d="M10.7605 17.8291H9.67216C9.38131 17.8291 9.14597 17.5937 9.14597 17.3029C9.14597 17.012 9.38131 16.7767 9.67216 16.7767H10.7605C11.0513 16.7767 11.2867 17.012 11.2867 17.3029C11.2867 17.5937 11.0513 17.8291 10.7605 17.8291Z"
        fill="#696969"
      />
      <path
        d="M13.3359 15.9062H12.2476C11.9567 15.9062 11.7214 15.6709 11.7214 15.3801C11.7214 15.0892 11.9567 14.8539 12.2476 14.8539H13.3359C13.6267 14.8539 13.8621 15.0892 13.8621 15.3801C13.8621 15.6709 13.6267 15.9062 13.3359 15.9062Z"
        fill="#696969"
      />
      <path
        d="M10.7605 15.9062H9.67216C9.38131 15.9062 9.14597 15.6709 9.14597 15.3801C9.14597 15.0892 9.38131 14.8539 9.67216 14.8539H10.7605C11.0513 14.8539 11.2867 15.0892 11.2867 15.3801C11.2867 15.6709 11.0513 15.9062 10.7605 15.9062Z"
        fill="#696969"
      />
      <path
        d="M13.3359 13.9844H12.2476C11.9567 13.9844 11.7214 13.7491 11.7214 13.4583C11.7214 13.1674 11.9567 12.9321 12.2476 12.9321H13.3359C13.6267 12.9321 13.8621 13.1674 13.8621 13.4583C13.8621 13.7491 13.6267 13.9844 13.3359 13.9844Z"
        fill="#696969"
      />
      <path
        d="M10.7605 13.9844H9.67216C9.38131 13.9844 9.14597 13.7491 9.14597 13.4583C9.14597 13.1674 9.38131 12.9321 9.67216 12.9321H10.7605C11.0513 12.9321 11.2867 13.1674 11.2867 13.4583C11.2867 13.7491 11.0513 13.9844 10.7605 13.9844Z"
        fill="#696969"
      />
      <path
        d="M19.1835 14.6093H17.0068C16.716 14.6093 16.4806 14.3739 16.4806 14.0831C16.4806 13.7923 16.716 13.5569 17.0068 13.5569H19.1835C19.4743 13.5569 19.7097 13.7923 19.7097 14.0831C19.7097 14.3739 19.4743 14.6093 19.1835 14.6093Z"
        fill="#696969"
      />
      <path
        d="M19.1835 12.5878H17.0068C16.716 12.5878 16.4806 12.3525 16.4806 12.0616C16.4806 11.7708 16.716 11.5354 17.0068 11.5354H19.1835C19.4743 11.5354 19.7097 11.7708 19.7097 12.0616C19.7097 12.3525 19.4743 12.5878 19.1835 12.5878Z"
        fill="#696969"
      />
    </svg>
  );
};

export default AllAirportIcon;
